import { fetchWithAuth } from "../utils/fetchWithAuth";

const BASE = "/materials";

/* ===== helpers ===== */
const jsonOrThrow = async (res) => {
  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = (data && (data.message || data.error || data.detail)) || `HTTP ${res.status}`;
    const err = new Error(Array.isArray(msg) ? msg.join(", ") : msg);
    err.status = res.status; err.data = data; throw err;
  }
  return data;
};

/* ===== content ===== */
export async function getMaterialsContent() {
  const res = await fetchWithAuth(`${BASE}/content`, { method: "GET" });
  return jsonOrThrow(res);
}

export async function updateMaterialsContent(payload) {
  const sections = Array.isArray(payload?.sections) ? payload.sections : [];
  const clean = sections.map(s => ({
    title: String(s?.title || "").trim() || "Material",
    ...(s?.description ? { description: String(s.description).trim() } : {}),
    ...(s?.url ? { url: String(s.url).trim() } : {}),
    ...(s?.imageUrl ? { imageUrl: String(s.imageUrl).trim() } : {}),
    ...(s?.imagePublicId ? { imagePublicId: String(s.imagePublicId).trim() } : {}),
    ...(s?.category ? { category: String(s.category).trim() } : {}),
    ...(s?.fileUrl ? { fileUrl: String(s.fileUrl).trim() } : {}),
    ...(s?.filePublicId ? { filePublicId: String(s.filePublicId).trim() } : {}),
    ...(s?.createdAt ? { createdAt: String(s.createdAt) } : {}),
    ...(s?.updatedAt ? { updatedAt: String(s.updatedAt) } : {}),
  })).filter(s => s.title || s.description || s.url || s.imageUrl || s.fileUrl);

  const res = await fetchWithAuth(`${BASE}/content`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sections: clean }),
  });
  return jsonOrThrow(res);
}

/* ===== imágenes ===== */
export async function uploadMaterialImage(fileOrBlob) {
  const fd = new FormData();
  fd.append("file", fileOrBlob);
  const res = await fetchWithAuth(`${BASE}/content/upload-image`, {
    method: "POST",
    body: fd,
  });
  return jsonOrThrow(res); // { secureUrl, publicId, ... }
}

export async function deleteMaterialImageByUrl(imageUrl) {
  const res = await fetchWithAuth(`${BASE}/content/image`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ imageUrl }),
  });
  return jsonOrThrow(res);
}

/* ===== archivos ===== */
export async function uploadMaterialFile(fileOrBlob) {
  const fd = new FormData();
  fd.append("file", fileOrBlob);
  const res = await fetchWithAuth(`${BASE}/content/upload-file`, {
    method: "POST",
    body: fd,
  });
  return jsonOrThrow(res); // { secureUrl, publicId, ... }
}

/* ===== categorías ===== */
export async function getMaterialCategories() {
  const res = await fetchWithAuth(`${BASE}/categories`, { method: "GET" });
  return jsonOrThrow(res);
}

export async function getMaterialCategory(key) {
  const res = await fetchWithAuth(`${BASE}/categories/${key}`, { method: "GET" });
  return jsonOrThrow(res);
}

export async function createMaterialCategory(payload) {
  const res = await fetchWithAuth(`${BASE}/categories`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

export async function updateMaterialCategory(key, payload) {
  const res = await fetchWithAuth(`${BASE}/categories/${key}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}

export async function deleteMaterialCategory(key) {
  const res = await fetchWithAuth(`${BASE}/categories/${key}`, {
    method: "DELETE",
  });
  return jsonOrThrow(res);
}

export async function uploadMaterialCategoryImage(fileOrBlob) {
  const fd = new FormData();
  fd.append("file", fileOrBlob);
  const res = await fetchWithAuth(`${BASE}/categories/upload-image`, {
    method: "POST",
    body: fd,
  });
  return jsonOrThrow(res); // { secureUrl, publicId, ... }
}

export async function deleteMaterialCategoryImageByUrl(imageUrl) {
  const res = await fetchWithAuth(`${BASE}/content/image`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ imageUrl }),
  });
  return jsonOrThrow(res);
}